import type { FormEvent } from 'react';
import React from 'react';
import { SignupFlow } from 'corgi-types';

import { useLoginUrl } from 'common/hooks/form/login';
import { useLocalization } from 'common/providers/LocaleProvider';
import { HomeClubSectionEventPlacement } from 'common/tracking/home-club';
import { CartTopBannerEventName } from '../../../cart-top-banner/components/constants';
import type { BaseComponentProps } from '../../types';
import CTAButton from '../shared/BaseCTAButton';

interface CartSubmitButtonProps extends BaseComponentProps {
  isModalEnabled?: boolean;
  isLoading: boolean;
  handleModalOpen: () => void;
  handleSubmit: (event: FormEvent<HTMLFormElement>) => void;
}

const CartSubmitButton = ({
  isLoading,
  isLoggedIn,
  trackingProps,
  handleSubmit,
  handleModalOpen,
  isModalEnabled = true,
}: CartSubmitButtonProps) => {
  const { t } = useLocalization();
  const loginURL = useLoginUrl(SignupFlow.CartHomeClub);
  const buttonLabel = t('h24_hc_submit_btn_label');

  const onButtonClick = (event: FormEvent<HTMLFormElement>) => {
    if (!isLoggedIn) {
      window.location.href = loginURL;
    } else if (isModalEnabled) {
      handleModalOpen();
    } else {
      handleSubmit(event);
    }
  };

  return (
    <CTAButton
      tracking={{
        eventName: trackingProps?.eventName ?? CartTopBannerEventName.Click,
        placement: HomeClubSectionEventPlacement.Modal,
        text: buttonLabel,
        ...trackingProps,
      }}
      isLoading={isLoading}
      onClick={onButtonClick}
    >
      {buttonLabel}
    </CTAButton>
  );
};

export default CartSubmitButton;
